export class Response_1 {
    constructor(
        public isStrategicPlanningDocumentsAvailable: boolean | null,
        public strategicPlanningDocumentsAvailableDetails: string | null,
    ) {
        this.isStrategicPlanningDocumentsAvailable = isStrategicPlanningDocumentsAvailable;
        this.strategicPlanningDocumentsAvailableDetails = strategicPlanningDocumentsAvailableDetails;
    }

    static init = () => new Response_1(null, null);
}